"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const c=(t,i,e)=>{t.type===i&&e(t),t.children?.forEach(r=>c(r,i,e))};exports.visit=c;
//# sourceMappingURL=mdast.cjs.map
